import { render } from "./NewGarden.vue?vue&type=template&id=227874ca&scoped=true"
import script from "./NewGarden.vue?vue&type=script&lang=js"
export * from "./NewGarden.vue?vue&type=script&lang=js"

import "./NewGarden.vue?vue&type=style&index=0&id=227874ca&lang=scss&scoped=true"

import exportComponent from "/home/forge/app-ticket.grandigiardini.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227874ca"]])

export default __exports__